export function updateUrl(params) {
  const url = window.location.origin + window.location.pathname + '?' + $.param(params)
  history.pushState(null, null, url)
  return { type: 'IGNORE' }
}
